@let s = strength();
@let active = activeBars(s);
@let color = barColor(s);

<!--
  Bars only. The word next to them ("Good", "Fair") said the same thing twice
  and was the third piece of text in a row of three status chips; the tooltip
  carries it, along with the throughput and latency behind it.
-->
<div class="flex items-center cursor-default" [matTooltip]="tooltipText">
  <div class="flex items-end gap-px h-3" role="img" [attr.aria-label]="tooltipText">
    @for (height of barHeights; track $index) {
      <div
        class="w-[3px] rounded-sm transition-colors duration-300"
        [style.height.px]="height"
        [style.background-color]="$index < active ? color : '#d1d5db'"></div>
    }
  </div>
</div>
